import styled from "styled-components";
import { Button, Form, Input } from "antd";
import FormButton from "../../components/FormCustom2/Button";

export const AuthContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  padding-bottom: 118px;
`;
export const AuthView = styled.div`
  width: 400px;
  padding-bttom: 66px;
  // height: 555px;
  // background: #ffffff;
  // box-shadow: 0px 18px 36px rgba(101, 124, 199, 0.501961);
  // border-radius: 30px;
  // display: flex;
  // align-items: flex-start;
  // justify-content: flex-start;
  // overflow: hidden;

  @media screen and (max-width: 1024px) {
    & {
      height: 100%;
      width: 100%;
      box-shadow: none;
    }
  }
`;
export const AuthViewLeft = styled.div`
  width: 410px;
  height: 100%;
  background-size: cover;

  @media screen and (max-width: 1024px) {
    & {
      display: none;
    }
  }
`;
export const AuthViewRight = styled.div`
  flex: 1;
  padding: 52px 73px;

  @media screen and (max-width: 1024px) {
    & {
      padding: 50px 20px 50px 20px;
    }
  }
`;

export const AuthForm = styled.div`
  text-align: center;
`;
export const AuthFormTitle = styled.div`
  font-weight: 400;
  font-size: 30px;
  line-height: 30px;
  letter-spacing: -0.96px;
  color: #000000;
  text-align: start;
`;

export const AuthFormTitleForgot = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #000000;
  text-align: start;
`;
export const AuthFormItem = styled(Form.Item)`
  position: relative;

  & .ant-form-item-row {
    display: block;
  }

  & .ant-form-item-label {
    display: block;
  }

  & .ant-form-item-label > label {
    display: block;
    font-weight: 700;
    font-size: 16px;
    line-height: 15px;
    color: #848484;
    text-align: left;
    width: 100%;
    height: 24px;
  }

  & .ant-form-item-explain-error {
    text-align: left;
  }
`;
export const AuthFormButton = styled(Button)`
  width: 250px;
  height: 50px;
  background: linear-gradient(
    157.48deg,
    #548feb -5.34%,
    #4d67c1 103.65%
  ) !important;
  box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333) !important;
  border-radius: 10px !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #ffffff !important;
  margin-top: 20px;
  border: none !important;

  &.ant-btn[disabled] {
    background: linear-gradient(
      157.48deg,
      #efefef -5.34%,
      #ffffff 103.65%
    ) !important;
    box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333) !important;
    border-radius: 10px !important;
    border: none;
    color: #bfbfbf !important;
  }
`;

export const ButtonSubmit = styled(FormButton)`
  max-width: 100%;
  width: 400px;
`;

export const AuthFormButtonCancel = styled(Button)`
  width: 150px;
  height: 50px;
  margin-right: 24px;
  background: linear-gradient(
    157.48deg,
    #ffffff -5.34%,
    #ffffff 103.65%
  ) !important;
  box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333) !important;
  border-radius: 10px !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #4d67c1 !important;
  margin-top: 20px;
  border: none !important;

  &.ant-btn[disabled] {
    background: linear-gradient(
      157.48deg,
      #efefef -5.34%,
      #ffffff 103.65%
    ) !important;
    box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333) !important;
    border-radius: 10px !important;
    border: none;
    color: #bfbfbf !important;
  }
`;
export const AuthFormSubmit = styled.div`
  @media screen and (max-width: 1024px) {
    & {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100%);
    }

    & button {
      width: 50%;
    }
  }
`;
export const AuthFormInput = styled(Input)`
  border: none;
  height: 50px;
  background: #ffffff;
  border-radius: 8px;
  font-size: 16px;

`;
export const Sendcode = styled.div`
  
  @media screen and (max-width: 1024px) {
    & {
      margin-top: 30px;
    }
  }
`;
export const AuthFormInputSpan = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 25px;
  text-align: right;
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 44px;
  z-index: 1;
  &.auth {
    top: 37px;
  }

  @media screen and (max-width: 1024px) {
    & {
      top: 52px;
    }

    &.auth {
      top: 43px;
    }
  }
`;
export const AuthFormInputPassword = styled(Input.Password)`
  border: none;
  height: 50px;
  background: #ffffff;
  border-radius: 8px;
  font-size: 16px;

  & input {
    font-size: 16px;
  }
 
`;

export const ModeTabs = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  margin-top: -24px;
`;
export const ModeTab = styled.div`
  height: 30px;
  background: #ffffff;
  box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
  border-radius: 15px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #485ea8;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(50% - 10px);

  &.active {
    background: linear-gradient(157.48deg, #548feb -5.34%, #4d67c1 103.65%);
    box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
    border-radius: 15px;
    color: #fff;
  }
`;

export const AuthOr = styled.div`
  position: relative;
  text-align: center;
  margin: 30px 0 24px 0;
  width: 100%;

  &:after {
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    top: 12px;
    left: 0;
    z-index: 1;
    content: "";
  }

  & > span {
    width: 69px;
    background-color: #f5f5f5;
    position: relative;
    z-index: 2;
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    text-align: center;
    color: #000000;
    text-transform: lowercase;
  }
`;
export const AuthSocialButton = styled(AuthFormButtonCancel)`
  width: 275px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 16px;

  & span {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    display: inline-block;
    margin-left: 12px;
  }

  & svg {
    height: 22px;
  }
`;

export const TextContinue = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  color: #000000;
  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;

export const BlockIconSocial = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  @media (max-width: 1024px) {
    gap: 15px;
  }
`;

export const IconSocial = styled.div`
  width: 50px;
  height: 50px;
  background: linear-gradient(157.48deg, #ffffff -5.34%, #ffffff 103.65%);
  border: 1px solid rgba(112, 112, 112, 0.15);
  border-radius: 10px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    width: 42px;
    height: 42px;
    & svg {
      width: 19px;
      height: 19px;
    }
  }
`;

export const AppleIcon = (props) => {
  return (
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9190_5157)">
        <path
          d="M20.284 18.5711C19.9252 19.3932 19.5002 20.1506 19.0075 20.8461C18.3355 21.7947 17.7869 22.4506 17.3634 22.8153C16.7075 23.4138 16.0031 23.7197 15.2502 23.7373C14.709 23.7373 14.0575 23.5844 13.2987 23.2756C12.5369 22.9682 11.8369 22.8153 11.1972 22.8153C10.5267 22.8153 9.80607 22.9682 9.03548 23.2756C8.26489 23.5844 7.64283 23.7461 7.16783 23.7623C6.44577 23.7932 5.72518 23.4785 5.00607 22.8153C4.54724 22.4182 3.97371 21.7388 3.28548 20.7756C2.54724 19.7476 1.94136 18.555 1.46636 17.1961C0.957537 15.727 0.703125 14.305 0.703125 12.9285C0.703125 11.352 1.04724 9.99173 1.73548 8.85202C2.27665 7.93732 2.99724 7.21526 3.89871 6.68438C4.80018 6.15496 5.77371 5.88437 6.82224 5.86673C7.39577 5.86673 8.14871 6.0432 9.08401 6.38879C10.0149 6.73585 10.6149 6.91085 10.8767 6.91085C11.0722 6.91085 11.7384 6.70496 12.8649 6.29467C13.9311 5.91379 14.8311 5.75643 15.5678 5.81967C17.5649 5.97996 19.0664 6.75938 20.0649 8.16526C18.2781 9.23732 17.3943 10.7403 17.4119 12.6682C17.4281 14.1697 17.9781 15.4182 19.0575 16.4108C19.5472 16.8711 20.0943 17.227 20.7017 17.48C20.5708 17.8594 20.4325 18.2226 20.284 18.5711ZM15.7031 0.704963C15.7031 1.88143 15.2693 2.97996 14.4046 3.99761C13.3605 5.20643 12.0987 5.90496 10.7296 5.79467C10.7119 5.65349 10.7017 5.50496 10.7017 5.34908C10.7017 4.21967 11.1972 3.01085 12.0796 2.02261C12.5193 1.52261 13.0796 1.10643 13.7575 0.774081C14.434 0.44614 15.0752 0.265257 15.6781 0.234375C15.6958 0.391728 15.7031 0.549081 15.7031 0.704963Z"
          fill="#1E2329"
        />
      </g>
      <defs>
        <clipPath id="clip0_9190_5157">
          <rect
            width="20"
            height="23.5294"
            fill="white"
            transform="translate(0.703125 0.234375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FacebookIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9190_5161)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9952 0.234375C14.1863 0.25938 16.1659 0.79796 17.9337 1.84986C19.6808 2.881 21.1338 4.34292 22.154 6.09609C23.1998 7.87452 23.7351 9.86609 23.7601 12.0705C23.698 15.0871 22.7465 17.6632 20.9057 19.7994C19.065 21.9357 16.7078 23.2574 14.2671 23.7638V15.3069H16.5745L17.0962 11.9835H13.6024V9.80671C13.5832 9.35543 13.7259 8.91231 14.0048 8.55699C14.2842 8.20091 14.7763 8.01372 15.481 7.99543H17.5905V5.08426C17.5604 5.07432 17.273 5.03602 16.729 4.96873C16.1118 4.89657 15.4911 4.85795 14.8698 4.85301C13.4635 4.85972 12.3513 5.25632 11.533 6.04317C10.7147 6.83002 10.2969 7.96821 10.2793 9.45779V11.9835H7.62057V15.3069H10.2793V23.7638C7.28253 23.2574 4.92526 21.9357 3.08454 19.7994C1.24382 17.6632 0.292569 15.0871 0.230469 12.0705C0.25522 9.86609 0.790572 7.87452 1.83627 6.09609C2.85652 4.34292 4.30977 2.881 6.05654 1.84986C7.82434 0.79796 9.80382 0.25938 11.9952 0.234375Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_9190_5161">
          <rect
            width="23.5296"
            height="23.5294"
            fill="white"
            transform="translate(0.230469 0.234375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WalletIcon = (props) => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9190_5166)">
        <mask
          id="mask0_9190_5166"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="24"
        >
          <path
            d="M21.7154 0.236328H0.707031V23.7657H21.7154V0.236328Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_9190_5166)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7154 19.3882H16.598C14.9614 19.3882 13.6353 18.041 13.6353 16.3786V14.1898C13.6353 12.5274 14.9614 11.1802 16.598 11.1802H21.7154V9.81225C21.7154 9.01444 21.4029 8.24843 20.8482 7.68359C20.2922 7.12012 19.5381 6.80267 18.7527 6.80267C15.022 6.80267 7.4005 6.80267 3.66975 6.80267C2.88436 6.80267 2.13028 7.12012 1.57423 7.68359C1.01953 8.24843 0.707031 9.01444 0.707031 9.81225V20.7562C0.707031 21.554 1.01953 22.32 1.57423 22.8848C2.13028 23.4483 2.88436 23.7657 3.66975 23.7657H18.7527C19.5381 23.7657 20.2922 23.4483 20.8482 22.8848C21.4029 22.32 21.7154 21.554 21.7154 20.7562V19.3882ZM21.7154 12.8218V17.7466H16.598C15.8547 17.7466 15.2513 17.1337 15.2513 16.3786V14.1898C15.2513 13.4348 15.8547 12.8218 16.598 12.8218H21.7154ZM17.4158 14.4535C17.8681 14.4535 18.2346 14.8257 18.2346 15.2842C18.2346 15.7427 17.8681 16.1149 17.4158 16.1149C16.9644 16.1149 16.598 15.7427 16.598 15.2842C16.598 14.8257 16.9644 14.4535 17.4158 14.4535Z"
            fill="black"
          />
        </g>
        <mask
          id="mask1_9190_5166"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="24"
        >
          <path
            d="M21.7154 0.236328H0.707031V23.7657H21.7154V0.236328Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_9190_5166)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.16282 5.74111C3.33089 5.71922 3.50003 5.70827 3.67019 5.70827H14.0978L14.0968 5.70615L12.5681 1.61313C12.3708 1.08433 11.9744 0.656632 11.466 0.424689C10.9573 0.192473 10.38 0.174074 9.85838 0.375236C8.33729 0.960941 5.73965 1.96204 4.21755 2.54883C3.69699 2.7489 3.27595 3.15184 3.04761 3.66833C2.81901 4.18481 2.8009 4.77154 2.99893 5.30109L3.16282 5.74111Z"
            fill="black"
          />
        </g>
        <mask
          id="mask2_9190_5166"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="24"
        >
          <path
            d="M21.7154 0.236328H0.707031V23.7657H21.7154V0.236328Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_9190_5166)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2222 5.70827H18.7529C18.9867 5.70827 19.2195 5.72914 19.4468 5.76949C19.4391 5.74753 19.4315 5.72695 19.4241 5.70615C18.9877 4.53611 18.3328 2.78392 17.8964 1.61313C17.6981 1.08433 17.3017 0.656632 16.7931 0.424689C16.2857 0.192473 15.7073 0.174074 15.1868 0.375236L13.4932 1.02743C13.5234 1.09213 13.5502 1.15786 13.5752 1.22572L15.1039 5.31874C15.1513 5.44671 15.1912 5.57681 15.2222 5.70827Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_9190_5166">
          <rect
            width="21.0084"
            height="23.5294"
            fill="white"
            transform="translate(0.707031 0.236328)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InstagramIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9190_5182)">
        <path
          d="M17.0242 23.6673H6.97306C3.31093 23.6673 0.332031 20.6883 0.332031 17.0263V6.97501C0.332031 3.31318 3.31093 0.333984 6.97306 0.333984H17.0242C20.686 0.333984 23.6654 3.31318 23.6654 6.97501V17.0263C23.6654 20.6883 20.686 23.6673 17.0242 23.6673ZM6.97306 2.33401C4.41383 2.33401 2.33206 4.41593 2.33206 6.97501V17.0263C2.33206 19.5855 4.41397 21.6674 6.97306 21.6674H17.0242C19.5833 21.6674 21.6652 19.5855 21.6652 17.0263V6.97501C21.6652 4.41593 19.5833 2.33401 17.0242 2.33401H6.97306Z"
          fill="#323232"
        />
        <path
          d="M11.9988 17.975C8.70457 17.975 6.02441 15.295 6.02441 12.0007C6.02441 8.70646 8.70457 6.02631 11.9988 6.02631C15.293 6.02631 17.9731 8.70646 17.9731 12.0007C17.9731 15.295 15.293 17.975 11.9988 17.975ZM11.9988 8.02633C9.80732 8.02633 8.02429 9.80921 8.02429 12.0007C8.02429 14.1921 9.80717 15.9751 11.9988 15.9751C14.1904 15.9751 15.9731 14.1921 15.9731 12.0007C15.9731 9.80921 14.1902 8.02633 11.9988 8.02633Z"
          fill="#323232"
        />
        <path
          d="M19.6647 5.68441C19.6647 6.47747 19.0218 7.1202 18.2289 7.1202C17.4358 7.1202 16.793 6.47747 16.793 5.68441C16.793 4.89135 17.4358 4.24847 18.2289 4.24847C19.0218 4.24847 19.6647 4.89135 19.6647 5.68441Z"
          fill="#323232"
        />
      </g>
      <defs>
        <clipPath id="clip0_9190_5182">
          <rect
            width="23.3333"
            height="23.3333"
            fill="white"
            transform="translate(0.332031 0.333984)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GoogleIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9190_5191)">
        <path
          d="M5.50707 14.4326L4.69477 17.4646L1.7264 17.5275C0.839123 15.8821 0.335938 13.9994 0.335938 11.9987C0.335938 10.064 0.806372 8.23965 1.64048 6.63318H1.64096L4.28395 7.11789L5.44174 9.74472C5.19942 10.4513 5.0672 11.2097 5.0672 11.9987C5.06744 12.8551 5.22245 13.6757 5.50707 14.4326Z"
          fill="black"
        />
        <path
          d="M23.465 9.81927C23.5991 10.5249 23.6688 11.2538 23.6688 11.9987C23.6688 12.834 23.581 13.6488 23.4137 14.4347C22.8457 17.1091 21.3617 19.4442 19.3059 21.0967L19.3055 21.0962L15.9765 20.9262L15.5053 17.9853C16.8695 17.1852 17.9357 15.9334 18.4971 14.4347H12.2588V9.81927H23.465Z"
          fill="black"
        />
        <path
          d="M19.306 21.0962L19.3065 21.0967C17.3073 22.7039 14.7675 23.6654 12.0028 23.6654C7.5599 23.6654 3.69707 21.1821 1.72656 17.5275L5.50723 14.4329C6.49246 17.0623 9.02911 18.9341 12.0028 18.9341C13.2809 18.9341 14.4784 18.5885 15.5059 17.9854L19.306 21.0962Z"
          fill="black"
        />
        <path
          d="M19.4497 3.01798L15.67 6.1122C14.6066 5.44738 13.3495 5.06329 12.0028 5.06329C8.9617 5.06329 6.37784 7.02104 5.44189 9.74472L1.64111 6.63319H1.64062C3.58221 2.88983 7.49389 0.332031 12.0028 0.332031C14.8335 0.332031 17.429 1.34035 19.4497 3.01798Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_9190_5191">
          <rect
            width="23.3333"
            height="23.3333"
            fill="white"
            transform="translate(0.335938 0.332031)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
